import { axiosInstance as axios } from "services";

export const fetchSubCrewsPersonel = async () => {
  const { data } = await axios.get("/supplier/subcrewsPersonel");
  if (!data.success) throw new Error(data.error || "Failed to fetch sub crews personel");
  return data;
};

